var map = {
	"./ic-buy-x-get-y.png": 3152,
	"./ic-gift.png": 1021,
	"./ic-loyalty.png": 3153,
	"./ic-minimum-purchase.png": 3154,
	"./ic-set-menu.png": 3155
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 631;


//////////////////
// WEBPACK FOOTER
// ./app/assets/images ^\.\/ic\-.*\.png$
// module id = 631
// module chunks = 0